export const rolesKeys: any = {
  ROLE_COLLAB: "collab",
  ROLE_CANDIDATE: "candidate",
  ROLE_BENEF: "benef",
  ROLE_RH: "rh",
  ROLE_MANAGER: "manager",
  ROLE_ADMIN: "admin",
  ROLE_RECRUITER: "recruiter",
  ROLE_CRE: "cre",
  ROLE_ADVISOR: "advisor",
  ROLE_THIRD_PARTY: "third_party",
  // ROLE_ADMINREFERENTIAL: "admin_referential",
};

export default rolesKeys;
